import { FC, useEffect } from 'react';
import RedirectingAuth from '@acorn-portal/shared/src/pages/auth/RedirectingAuth';
import { useAuth } from 'react-oidc-context';

interface SecureRouteProps {
	Logo: React.FC<React.SVGProps<SVGSVGElement>>;
	children: React.ReactNode;
}

const SecureRoute: FC<SecureRouteProps> = ({ children, Logo }) => {
	const auth = useAuth();

	useEffect(() => {
		if (!auth.isAuthenticated && !auth.isLoading) {
			auth.signinRedirect();
		}
	}, [auth]);

	if (auth.isLoading && !auth.isAuthenticated) {
		return <RedirectingAuth Logo={Logo} />;
	}

	return children;
};

export default SecureRoute;
